module.exports = "/_next/static/images/footer3-c964d2dca5e5361e6f7864ab13b0e9a4.svg";